export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  coverImage: string;
  rating: number;
  year: number;
  region: string;
  type: string;
  tags: string[];
  viewCount: number;
  publishDate: string;
  featured: boolean;
}

export interface FAQ {
  question: string;
  answer: string;
}

export const categories: Category[] = [
  {
    slug: 'drama',
    name: '国产剧集',
    description: '精选亚洲各地优质国产高清剧集，涵盖古装、现代、悬疑等多种类型',
    icon: 'ri-tv-line',
  },
  {
    slug: 'movie',
    name: '高清电影',
    description: '汇聚亚洲国产高清电影佳作，动作、爱情、喜剧等多元题材',
    icon: 'ri-film-line',
  },
  {
    slug: 'variety',
    name: '热门综艺',
    description: '最新最热的亚洲国产高清综艺节目，真人秀、音乐、访谈一应俱全',
    icon: 'ri-live-line',
  },
  {
    slug: 'anime',
    name: '动漫动画',
    description: '国产高清动漫动画精选，热血、治愈、奇幻等风格多样',
    icon: 'ri-ghost-line',
  },
  {
    slug: 'documentary',
    name: '纪录片',
    description: '高品质国产纪录片，历史、自然、人文、美食等主题深度呈现',
    icon: 'ri-camera-lens-line',
  },
  {
    slug: 'short',
    name: '短剧微剧',
    description: '节奏明快的国产高清短剧微剧，轻松追剧不费时',
    icon: 'ri-smartphone-line',
  },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '《长安十二时辰》—— 国产古装剧的巅峰之作，高清画质重塑盛唐气象',
    excerpt: '这部改编自马伯庸同名小说的古装悬疑剧，以精良的制作、出色的演技和高清画质赢得了观众的一致好评。本文深度解析该剧为何能成为国产剧的标杆。',
    content: `<p>《长安十二时辰》以唐朝天宝三载为背景，讲述了由雷佳音饰演的张小敬与易烊千玺饰演的李必在十二个时辰内联手拯救长安的故事。该剧自播出以来，凭借其紧凑的叙事节奏、考究的历史细节以及电影级的高清画质，迅速成为国产剧的现象级作品。</p>
    <p>全剧以"反恐24小时"式的紧凑结构展开，每一集都对应一个时辰，剧情环环相扣、悬念迭起。导演曹盾对盛唐时期长安城的还原可谓精益求精——从坊市布局到服饰妆容，从饮食器皿到礼仪制度，无不考究。在高清画质下，这些细节被展现得淋漓尽致。</p>
    <p>剧中雷佳音饰演的张小敬，是一位被关押在死牢中的前不良帅，被李必临时启用查案。他粗犷不羁的外表下藏着对长安百姓深沉的爱，雷佳音将这一角色的复杂内心演绎得入木三分。而易烊千玺饰演的李必虽然年少，却展现出超乎年龄的沉稳与智慧。</p>
    <p>值得一提的是，该剧的美术设计和摄影水准达到了国产剧的新高度。无论是长安城宏伟的全景镜头，还是人物面部的微表情特写，在高清画质下都展现出令人惊叹的质感。服装道具的精美程度甚至可以媲美电影级别。</p>
    <p>《长安十二时辰》不只是一部优秀的国产高清剧集，更是一次对盛唐文化的生动复原。它让观众在享受紧张刺激的剧情之余，也得以一窥千年之前长安城的繁华景象。</p>`,
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20city%20scene%20at%20twilight%2C%20lanterns%20lighting%20up%20traditional%20architecture%2C%20dramatic%20cinematic%20lighting%2C%20historical%20costume%20drama%20aesthetic%2C%20warm%20golden%20and%20crimson%20tones%2C%20atmospheric%20fog%2C%20film%20grain%20texture%2C%20epic%20scale%20composition&width=800&height=450&seq=article-1-cover&orientation=landscape',
    rating: 9.2,
    year: 2019,
    region: '中国大陆',
    type: '古装悬疑',
    tags: ['长安十二时辰', '古装剧', '悬疑', '马伯庸', '雷佳音', '易烊千玺', '国产高清剧集'],
    viewCount: 1280000,
    publishDate: '2025-12-15',
    featured: true,
  },
  {
    id: 'article-2',
    title: '《流浪地球2》4K高清重制版上线 —— 国产科幻电影的里程碑',
    excerpt: '《流浪地球2》以更加宏大的叙事和震撼的视觉效果，将国产科幻电影推向了新的高度。4K高清重制版让观众在家也能体验影院级的视听享受。',
    content: `<p>作为《流浪地球》的前传，《流浪地球2》讲述了"太阳危机"来临之初，人类面临末日灾难与生命存续的双重挑战。影片由郭帆执导，吴京、李雪健、刘德华等实力派演员领衔主演，在2023年春节档上映后狂揽超过40亿票房。</p>
    <p>相比前作，《流浪地球2》在故事结构上更加宏大复杂。影片设置了三条叙事线：吴京饰演的刘培强参与太空电梯危机应对，刘德华饰演的图恒宇进行数字生命研究，李雪健饰演的周喆直在联合政府层面斡旋决策。三条线最终汇聚，共同呈现了人类面对灭顶之灾时的勇气与抉择。</p>
    <p>4K高清重制版在画质上有了质的飞跃。太空电梯崩塌的场面、月球碎片撞击地球的灾难场景、以及数字生命世界的光影变幻，在高清画质下呈现出令人窒息的视觉冲击力。每一帧画面都可以截图作为壁纸。</p>
    <p>影片在科幻设定上也更加扎实。"移山计划"、"逐月计划"、"数字生命计划"等概念的提出和展开，体现了中国科幻独特的价值观——不是逃离地球，而是带着家园一起走。这种"带着地球去流浪"的浪漫情怀，是国产科幻影片区别于好莱坞的核心魅力。</p>
    <p>《流浪地球2》证明了国产科幻电影已经具备了与世界顶级科幻电影比肩的实力。它不仅是一部优秀的科幻电影，更是一部关于希望、牺牲和人类命运共同体的深刻寓言。</p>`,
    category: 'movie',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20with%20Earth%20in%20background%2C%20dramatic%20sci-fi%20cinematic%20scene%2C%20blue%20planet%20glow%2C%20massive%20engines%2C%20epic%20scale%2C%20deep%20space%20atmosphere%2C%20film%20poster%20quality%2C%20clean%20minimal%20background&width=800&height=450&seq=article-2-cover&orientation=landscape',
    rating: 8.8,
    year: 2023,
    region: '中国大陆',
    type: '科幻冒险',
    tags: ['流浪地球2', '科幻电影', '吴京', '刘德华', '郭帆', '国产高清电影', '4K重制'],
    viewCount: 2560000,
    publishDate: '2026-01-20',
    featured: true,
  },
  {
    id: 'article-3',
    title: '《繁花》—— 王家卫首部电视剧，沪上风情高清还原',
    excerpt: '王家卫导演耗时三年打造的首部电视剧《繁花》，以极致的画面美学和细腻的情感描绘，将九十年代上海的繁华与迷离展现得淋漓尽致。',
    content: `<p>《繁花》改编自金宇澄的同名小说，由王家卫执导并担任监制，胡歌、马伊琍、唐嫣、辛芷蕾等主演。该剧以九十年代初的上海为背景，讲述了青年阿宝在改革开放浪潮中的商海沉浮与情感纠葛。</p>
    <p>全剧最大的看点莫过于王家卫标志性的视觉美学。每一帧画面都经过精心调色和构图，上海的弄堂、黄河路的霓虹灯、和平饭店的华丽内饰，在高清画质下呈现出油画般的质感。王家卫用他独特的镜头语言，将九十年代上海的繁华与躁动、欲望与失落刻画得入木三分。</p>
    <p>胡歌饰演的阿宝，从一个普通青年逐步成长为商界精英。他的表演内敛而富有层次，眼神中既有年轻人的锐气，又有历经沧桑后的沉淀。马伊琍饰演的玲子、唐嫣饰演的汪小姐、辛芷蕾饰演的李李，三位女性角色各具魅力，与阿宝的情感纠葛构成了剧中最动人的部分。</p>
    <p>《繁花》的配乐同样精彩，大量使用了九十年代的经典金曲，配合王家卫式的慢镜头和独白，营造出独特的怀旧氛围。剧中对上海话的大量使用也增添了浓郁的地域特色，让整部剧散发出独特的"上海味道"。</p>
    <p>作为王家卫的首部电视剧作品，《繁花》延续了他电影作品中的美学追求，同时又在叙事上更加丰富和完整。它证明了优秀的导演无论在大银幕还是小荧屏上，都能创造出令人难忘的作品。</p>`,
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20Nanjing%20Road%20neon%20lights%20at%20night%2C%20retro%20Chinese%20cityscape%2C%20warm%20golden%20and%20red%20glow%2C%20cinematic%20lighting%2C%20nostalgic%20atmosphere%2C%20wet%20pavement%20reflections%2C%20film%20noir%20aesthetic%2C%20clean%20composition&width=800&height=450&seq=article-3-cover&orientation=landscape',
    rating: 9.0,
    year: 2024,
    region: '中国大陆',
    type: '都市情感',
    tags: ['繁花', '王家卫', '胡歌', '上海', '国产高清剧集', '都市剧', '金宇澄'],
    viewCount: 3200000,
    publishDate: '2026-02-10',
    featured: true,
  },
  {
    id: 'article-4',
    title: '《这！就是街舞》第六季 —— 亚洲顶级舞者巅峰对决',
    excerpt: '《这！就是街舞》第六季汇聚了来自亚洲各地的顶尖舞者，以更炫目的舞台效果和高清画质，呈现了一场视觉与节奏的盛宴。',
    content: `<p>作为国内最具影响力的舞蹈竞技类综艺，《这！就是街舞》自第一季开播以来就收获了超高人气。第六季节目在赛制、舞台和选手阵容上全面升级，邀请了更多国际顶尖舞者参与，将节目的竞技水平和观赏性推向了新高度。</p>
    <p>本季最大的亮点之一是采用了全新的"街区对抗"赛制。四位明星队长各自带领一支队伍，通过多轮battle争夺最终的冠军。高清画质下，舞者们的每一个动作细节——从指尖的律动到脚步的节奏变化——都被清晰地捕捉和呈现。</p>
    <p>舞台设计方面，第六季投入了更大的制作成本。360度环绕式舞台配合先进的灯光和LED屏幕技术，为每一场表演创造了独特的视觉氛围。无论是Breaking的力量感、Popping的机械感，还是Locking的趣味性，都在精心设计的舞台效果加持下更加出彩。</p>
    <p>参赛选手中不乏国际知名的街舞大神，他们与国内顶尖舞者的碰撞产生了无数令人拍案叫绝的名场面。特别值得一提的是几位来自日本和韩国的选手，他们将亚洲舞蹈文化的共性融入了各自独特的表现风格中。</p>
    <p>《这！就是街舞》第六季不仅是一档综艺节目，更是一个展示亚洲街舞文化多样性和创造力的平台。透过高清镜头，观众能够感受到舞者们对街舞的热爱与执着。</p>`,
    category: 'variety',
    coverImage: 'https://readdy.ai/api/search-image?query=Dynamic%20street%20dance%20performance%20on%20illuminated%20stage%2C%20dancer%20mid-air%20pose%2C%20colorful%20stage%20lighting%2C%20urban%20culture%20vibe%2C%20dramatic%20spotlights%2C%20energetic%20atmosphere%2C%20concert%20photography%20style%2C%20dark%20background&width=800&height=450&seq=article-4-cover&orientation=landscape',
    rating: 8.5,
    year: 2025,
    region: '中国大陆',
    type: '舞蹈竞技',
    tags: ['这！就是街舞', '综艺', '街舞', '国产高清综艺', '舞蹈竞技', '真人秀'],
    viewCount: 980000,
    publishDate: '2026-03-05',
    featured: false,
  },
  {
    id: 'article-5',
    title: '《深海》—— 国产动画电影的美学突破，粒子水墨惊艳世界',
    excerpt: '《深海》历时七年制作，首创"粒子水墨"动画技术，将中国传统水墨画与现代CG技术完美融合，打造了一场奇幻绚丽的视觉盛宴。',
    content: `<p>由田晓鹏导演（《大圣归来》导演）倾力打造的动画电影《深海》，讲述了一个离异家庭的小女孩参宿意外坠入深海世界，与一位神秘少年南河共同展开奇幻冒险的故事。影片以其独特的"粒子水墨"视觉风格，在国际动画界引起了广泛关注。</p>
    <p>"粒子水墨"是《深海》团队自主研发的一项全新技术。它将中国传统水墨画的笔触和韵味，通过数以亿计的彩色粒子在三维空间中呈现出来。在高清画质下，这些粒子仿佛有了生命，流动、旋转、绽放，创造出一种前所未见的视觉体验。</p>
    <p>影片的色彩运用极其大胆。深海世界中充满了饱和度极高的色彩——荧光粉、深海蓝、珊瑚橙——这些色彩在粒子的流动中交融变幻，营造出一个如梦似幻的水下世界。这种强烈的视觉风格与影片探讨的抑郁与治愈主题形成了巧妙的呼应。</p>
    <p>故事层面，《深海》触及了国产动画少有的题材——儿童心理健康和原生家庭创伤。小女孩参宿在父母离异后的内心挣扎，以及她在深海世界中的自我救赎之旅，触动了许多成年观众的内心。影片没有回避现实的沉重，而是通过奇幻的叙事给予了温暖的治愈。</p>
    <p>《深海》证明了中国动画不仅在技术上可以引领创新，在故事深度上同样可以触及世界级水准。它是国产动画电影的一次真正意义上的美学突破。</p>`,
    category: 'anime',
    coverImage: 'https://readdy.ai/api/search-image?query=Dreamy%20underwater%20fantasy%20world%20with%20flowing%20colorful%20ink%20particles%2C%20Chinese%20watercolor%20painting%20style%2C%20bioluminescent%20creatures%2C%20vibrant%20pink%20and%20blue%20hues%2C%20ethereal%20light%20rays%2C%20artistic%20animation%20aesthetic%2C%20clean%20minimal%20background&width=800&height=450&seq=article-5-cover&orientation=landscape',
    rating: 8.7,
    year: 2023,
    region: '中国大陆',
    type: '动画奇幻',
    tags: ['深海', '动画电影', '田晓鹏', '粒子水墨', '国产高清动漫', '国漫'],
    viewCount: 1890000,
    publishDate: '2026-04-18',
    featured: false,
  },
  {
    id: 'article-6',
    title: '《风味人间》第四季 —— 以高清镜头探索亚洲谷物文明',
    excerpt: '陈晓卿团队倾力打造的美食纪录片《风味人间》第四季，将镜头对准亚洲各地的谷物文化，从麦田到餐桌，讲述人与谷物的千年故事。',
    content: `<p>《风味人间》系列纪录片由陈晓卿执导，以"在全球视野里审视中国美食的独特性"为核心理念。第四季以"谷物"为主题，跨越亚洲多个国家和地区，探寻小麦、水稻、玉米、小米等谷物在不同文化中的独特演变和烹饪智慧。</p>
    <p>本季的摄影水准堪称纪录片领域的天花板。超高清微距镜头下，面粉在指尖飞扬的瞬间、蒸汽在包子表面凝结的过程、面条在沸水中翻滚的姿态，都被以极其细腻的方式呈现。每一道美食的拍摄都经过精心布光和构图，画面美感堪比顶级美食摄影。</p>
    <p>节目在叙事上延续了《风味人间》一贯的"人与食物"的双线结构。它不仅展示美食的制作过程，更深入挖掘了食物背后的人文故事。从河南的老农守护着即将消失的传统小麦品种，到日本匠人手工制作荞麦面的执着，再到印度家庭用传统方式制作馕饼的日常，每一个故事都让人感受到食物所承载的文化和情感。</p>
    <p>解说词由陈晓卿亲自撰写，文字优美而富有诗意。配合着精心制作的配乐和高质量的现场收音，整部纪录片的视听体验堪称完美。高清画质让观众仿佛能够闻到食物散发的香气。</p>
    <p>《风味人间》第四季不仅是一部关于食物的纪录片，更是一次跨越国界的人文之旅。它让我们看到，尽管亚洲各地的文化千差万别，但对美好食物的追求却是共通的。</p>`,
    category: 'documentary',
    coverImage: 'https://readdy.ai/api/search-image?query=Golden%20wheat%20field%20at%20sunset%2C%20traditional%20Chinese%20steamed%20buns%20in%20bamboo%20steamer%2C%20warm%20ambient%20light%2C%20food%20documentary%20cinematic%20style%2C%20shallow%20depth%20of%20field%2C%20rustic%20kitchen%20background%2C%20steam%20rising%2C%20artisan%20cooking&width=800&height=450&seq=article-6-cover&orientation=landscape',
    rating: 9.4,
    year: 2025,
    region: '中国大陆',
    type: '美食纪录',
    tags: ['风味人间', '纪录片', '美食', '陈晓卿', '国产高清纪录片', '谷物'],
    viewCount: 750000,
    publishDate: '2026-05-22',
    featured: false,
  },
  {
    id: 'article-7',
    title: '《狂飙》4K修复版 —— 扫黑除恶题材的现象级爆款',
    excerpt: '《狂飙》以横跨二十年的叙事格局，讲述了京海市一线刑警安欣与黑恶势力长达二十年的生死较量。4K修复版让这部国剧之光焕发新生。',
    content: `<p>《狂飙》自播出以来便一路"狂飙"，成为近年来最具社会影响力的国产剧集之一。该剧由徐纪周执导，张译、张颂文、李一桐等主演，通过刑警安欣与黑社会头目高启强二十年的恩怨纠葛，展现了中国扫黑除恶斗争的艰辛与决心。</p>
    <p>张颂文在剧中饰演的高启强堪称教科书级的反派塑造。从一个被欺负的鱼贩到称霸一方的黑社会大佬，人物的每一步转变都有充分的心理动机和行为逻辑。张颂文用极其细腻的表演，将一个复杂的反派人物刻画得令人既恨又怜。4K修复版中，他面部每一个细微的表情变化都清晰可见。</p>
    <p>张译饰演的安欣同样出彩。他从意气风发的年轻刑警变成了满头白发的中年人，二十年的坚守付出了青春、爱情乃至健康的代价。张译用内敛而深沉的表演，诠释了一个普通人在正义与邪恶较量中的坚守与牺牲。</p>
    <p>剧集在叙事上采用了双线并行的结构——一条是2000年初安欣与高启强的初次交锋，一条是2021年扫黑除恶督导组进驻后的收网阶段。两条线交叉剪辑，悬念丛生，让观众欲罢不能。</p>
    <p>《狂飙》的成功不仅在于其精彩的剧情和出色的表演，更在于它对社会现实的深刻洞察。它揭示了黑恶势力滋生的土壤，也展现了法治社会建设的不易。4K修复版以更高清的画质让这部经典之作焕发新生。</p>`,
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20rainy%20Chinese%20city%20street%20at%20night%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20police%20car%20lights%2C%20crime%20drama%20aesthetic%2C%20moody%20atmosphere%2C%20noir%20cinematography%2C%20urban%20China%20setting%2C%20high%20contrast%20lighting&width=800&height=450&seq=article-7-cover&orientation=landscape',
    rating: 9.1,
    year: 2023,
    region: '中国大陆',
    type: '犯罪剧情',
    tags: ['狂飙', '张颂文', '张译', '扫黑除恶', '国产高清剧集', '犯罪剧', '4K修复'],
    viewCount: 4500000,
    publishDate: '2026-06-08',
    featured: true,
  },
  {
    id: 'article-8',
    title: '《一年一度喜剧大赛》第三季 —— 新喜剧人的狂欢盛宴',
    excerpt: '《一年一度喜剧大赛》第三季延续了前两季的高水准，汇聚了更多新生代喜剧人才，以sketch、漫才、默剧等多种形式为观众带来欢笑。',
    content: `<p>《一年一度喜剧大赛》由爱奇艺出品，马东担任主持人，黄渤、于和伟等担任组委会成员。第三季在保持前两季核心模式的基础上，引入了更多的喜剧形式和国际化的创作理念。</p>
    <p>本季最令人惊喜的是参赛选手的多样性。除了传统的喜剧演员，还有来自话剧舞台、短视频平台、甚至相声园子的各路人才。他们带来了风格各异的作品——从讽刺职场文化的sketch到致敬经典的漫才，从一人分饰多角的独角戏到融合了肢体剧元素的创新喜剧。</p>
    <p>节目在舞美设计上也有了升级。高清画质下的舞台效果更加丰富，灯光和布景的变换为每一个作品营造了恰到好处的氛围。特别是几个融合了歌舞元素的喜剧作品，在精美的舞台加持下效果翻倍。</p>
    <p>节目中最打动人心的是创作者们对生活的独特观察。最好的喜剧往往源于最真实的日常，选手们从普通人的生活中提炼出幽默元素，让观众在欢笑中看到了自己的影子。无论是打工人的心酸、父母的唠叨、还是情侣间的日常拌嘴，都被巧妙地转化为令人捧腹的喜剧作品。</p>
    <p>《一年一度喜剧大赛》第三季证明了好的喜剧不是低俗的搞笑，而是有思想、有态度、有温度的艺术创作。它为中国喜剧注入了新的活力。</p>`,
    category: 'variety',
    coverImage: 'https://readdy.ai/api/search-image?query=Bright%20comedy%20stage%20with%20colorful%20spotlights%2C%20comedians%20performing%20on%20stage%2C%20theater%20atmosphere%2C%20warm%20lighting%2C%20entertaining%20show%20vibe%2C%20professional%20stage%20photography%2C%20clean%20background%2C%20joyful%20energy&width=800&height=450&seq=article-8-cover&orientation=landscape',
    rating: 8.3,
    year: 2025,
    region: '中国大陆',
    type: '喜剧竞技',
    tags: ['一年一度喜剧大赛', '综艺', '喜剧', '马东', '国产高清综艺', 'sketch'],
    viewCount: 620000,
    publishDate: '2026-07-15',
    featured: false,
  },
  {
    id: 'article-9',
    title: '《山海情》高清重制 —— 脱贫攻坚的动人篇章',
    excerpt: '正午阳光出品的《山海情》以真实故事为蓝本，讲述了宁夏西海固地区人民在福建对口帮扶下脱贫致富的感人历程。高清重制版让这份感动更加清晰。',
    content: `<p>《山海情》由孔笙、孙墨龙执导，黄轩领衔主演，张嘉益、闫妮、黄觉、姚晨、郭京飞等实力派演员联袂出演。该剧以宁夏西海固地区的真实脱贫故事为蓝本，展现了在中国东西部协作扶贫政策下，西海固人民从荒芜的黄土高原搬迁到闽宁镇、发展特色产业、最终摆脱贫困的奋斗历程。</p>
    <p>黄轩在剧中饰演的马得福是一位基层扶贫干部，他质朴而坚定的表演将一个普通人在时代洪流中的担当与坚守刻画得真实动人。剧中大量使用当地方言，黄轩为此专门学习了宁夏方言，其地道的口音为角色增添了极强的说服力。</p>
    <p>该剧在美术和摄影方面同样精益求精。黄土高原的苍凉壮阔、移民新村的从无到有、蘑菇产业从试验田到大棚种植的过程，都在高清镜头下被真实记录。剧中对1990年代至2010年代中国农村变迁的还原极为考究，每一个道具、每一件服饰都经得起推敲。</p>
    <p>《山海情》最打动人心的力量来自于它的真实。剧中许多情节都取材于真实的脱贫故事——福建农林大学的菌草技术专家林占熺教授、闽宁镇的第一批移民、在戈壁滩上种出蘑菇的农民——这些人物的原型都在现实生活中真实存在。</p>
    <p>这是一部不需要煽情却让人热泪盈眶的作品。它用平实的镜头语言讲述了一个关于坚韧、希望和改变的故事。高清重制版让这部精品剧集以更好的画质被新一代观众发现。</p>`,
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Vast%20loess%20plateau%20landscape%20in%20northwest%20China%2C%20golden%20sunset%20light%2C%20traditional%20rural%20village%2C%20earthy%20warm%20tones%2C%20cinematic%20wide%20shot%2C%20agricultural%20scenery%2C%20dramatic%20clouds%2C%20clean%20natural%20composition&width=800&height=450&seq=article-9-cover&orientation=landscape',
    rating: 9.3,
    year: 2021,
    region: '中国大陆',
    type: '时代剧情',
    tags: ['山海情', '黄轩', '正午阳光', '脱贫攻坚', '国产高清剧集', '时代剧'],
    viewCount: 2100000,
    publishDate: '2026-08-01',
    featured: false,
  },
  {
    id: 'article-10',
    title: '《封神第一部》加长版 —— 国产神话史诗的野心之作',
    excerpt: '乌尔善导演十年磨一剑的《封神第一部》，以宏大的神话世界观和震撼的视觉效果，开创了国产神话史诗电影的新纪元。加长版新增30分钟未公开内容。',
    content: `<p>《封神第一部：朝歌风云》是乌尔善导演"封神三部曲"的开篇之作，改编自中国古典神魔小说《封神演义》。影片以商朝末年为背景，讲述了殷商王子殷寿（纣王）在狐妖妲己的蛊惑下暴虐无道，引发天谴，姜子牙携封神榜下山寻找天下共主的故事。</p>
    <p>影片最大的看点之一是它对传统封神故事的全新解读。乌尔善并没有简单地将纣王塑造成一个脸谱化的暴君，而是赋予了这个角色更多的复杂性和悲剧色彩。费翔饰演的殷寿既有王者的威严，又有被欲望吞噬的挣扎，表演层次丰富。</p>
    <p>视觉特效方面，《封神第一部》达到了国产电影的新高度。雷震子的翅膀、哪吒的风火轮、申公豹的飞头术——这些传统神话中的经典元素在先进特效的加持下被赋予了震撼的视觉冲击力。加长版新增的特效镜头更是让整部影片的视觉密度进一步提升。</p>
    <p>美术设计同样令人赞叹。影片中的朝歌城融合了商周时期的历史元素和现代审美，既有远古文明的粗犷质感，又不失神话世界的神秘美感。服装道具的设计参考了大量商周时期的出土文物，在历史真实与艺术想象之间找到了平衡。</p>
    <p>加长版新增的30分钟内容主要集中在人物背景的补充和几场关键战役的扩展上，让整个故事的逻辑更加完整，人物动机更加清晰。对于已经看过影院版的观众来说，加长版带来了全新的观影体验。</p>`,
    category: 'movie',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20palace%20interior%2C%20grand%20throne%20room%2C%20golden%20dragon%20decorations%2C%20mythological%20atmosphere%2C%20dramatic%20torch%20lighting%2C%20cinematic%20composition%2C%20bronze%20age%20aesthetic%2C%20dark%20moody%20background&width=800&height=450&seq=article-10-cover&orientation=landscape',
    rating: 8.1,
    year: 2023,
    region: '中国大陆',
    type: '神话史诗',
    tags: ['封神', '乌尔善', '费翔', '神话', '国产高清电影', '史诗', '加长版'],
    viewCount: 1750000,
    publishDate: '2026-01-05',
    featured: true,
  },
  {
    id: 'article-11',
    title: '《雾山五行》第二季 —— 国产打斗动画的极致',
    excerpt: '六年磨一剑的《雾山五行》第二季延续了前作的超高口碑，以令人窒息的打斗场面和独特的泼墨山水画风，再次刷新了国产动画的上限。',
    content: `<p>《雾山五行》由林魂导演及其小团队耗费六年时间独立制作完成，是一部融合了中国传统五行元素和武侠精神的原创动画。第二季在继承第一季超高水准的基础上，在剧情深度和打斗设计上更进一步。</p>
    <p>该动画最令人惊叹的是其独一无二的打斗风格。每一场打斗都如同泼墨山水画在动态中展开——墨色与彩色的碰撞、线条与色块的纠缠、速度与力量的对决——在高清画质下呈现出令人窒息的视觉冲击。导演林魂本身就是一位出色的原画师，他亲自绘制了剧中大量的关键帧。</p>
    <p>第二季在剧情上更加丰富。五行使者各自的身世和使命被逐一揭示，妖兽世界的内部矛盾也逐渐浮出水面。故事不再是简单的正邪对立，而是涉及了人性、选择与牺牲等更深层次的主题。角色的情感线也处理得更加细腻。</p>
    <p>配乐方面，《雾山五行》大量使用了中国传统乐器——古琴、笛子、琵琶、二胡——与现代电子音乐的结合，创造出一种独特的"国风电子"风格。这种音乐风格与画面的泼墨山水画风形成了完美的呼应。</p>
    <p>虽然每集时长有限，但《雾山五行》证明了质量远比数量重要。它以极高的艺术追求和创作诚意，为国产动画树立了新的标杆。</p>`,
    category: 'anime',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20mountain%20landscape%2C%20misty%20peaks%2C%20flowing%20waterfall%2C%20martial%20arts%20atmosphere%2C%20black%20and%20color%20ink%20splashes%2C%20dynamic%20brushstrokes%2C%20traditional%20oriental%20aesthetic%2C%20clean%20artistic%20composition&width=800&height=450&seq=article-11-cover&orientation=landscape',
    rating: 9.5,
    year: 2024,
    region: '中国大陆',
    type: '动作奇幻',
    tags: ['雾山五行', '动画', '林魂', '打斗', '国产高清动漫', '泼墨', '国漫'],
    viewCount: 860000,
    publishDate: '2026-03-28',
    featured: false,
  },
  {
    id: 'article-12',
    title: '《舌尖上的中国》经典重制版 —— 高清再现中华美食地图',
    excerpt: '《舌尖上的中国》经典重制版以4K高清画质重新呈现了这部美食纪录片的传世之作，让观众以更清晰的视角重温中华美食的博大精深。',
    content: `<p>《舌尖上的中国》是中国最具影响力的美食纪录片IP，由陈晓卿执导的第一季被公认为该系列的巅峰之作。本次经典重制版采用最新的4K修复技术，将这部2012年的经典作品以更高清的画质重新呈现。</p>
    <p>第一季共七集，从《自然的馈赠》到《我们的田野》，每一集都围绕一个主题展开。它不仅仅展示了中国各地的美食，更重要的是讲述了食物背后的人与自然、人与传统、人与家庭的故事。松茸采摘者凌晨摸黑上山的艰辛、兰州拉面师傅数十年的手艺传承、东北酸菜坛子里的家乡味道——这些故事至今依然打动人心。</p>
    <p>4K重制版最大的提升在于画质的飞跃。原始素材经过专业的修复和调色，画面变得更加清晰锐利。食材的纹理、烹饪过程中的蒸汽、食物特写中的油光——这些细节在高清画质下被前所未有的呈现。特别是那些航拍镜头——梯田的层叠、渔船的出海、集市的繁华——在4K画质下展现出令人窒息的美感。</p>
    <p>配乐和解说依然是该片的灵魂。阿鲲创作的配乐融入了大量中国民族乐器元素，旋律优美而富有感染力。李立宏老师的解说沉稳有力，每一个字都仿佛带着食物的温度和香气。</p>
    <p>重制版不仅是一次技术上的升级，更是一次情感上的重温。它以更清晰的方式，让新一代观众感受到中华饮食文化的深厚底蕴和无穷魅力。</p>`,
    category: 'documentary',
    coverImage: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20kitchen%20with%20steaming%20wok%2C%20fresh%20vegetables%20and%20spices%2C%20warm%20ambient%20light%2C%20rustic%20wooden%20table%2C%20culinary%20arts%2C%20food%20photography%20style%2C%20shallow%20depth%20of%20field%2C%20cozy%20atmosphere&width=800&height=450&seq=article-12-cover&orientation=landscape',
    rating: 9.6,
    year: 2012,
    region: '中国大陆',
    type: '美食纪录',
    tags: ['舌尖上的中国', '纪录片', '美食', '陈晓卿', '国产高清纪录片', '4K重制'],
    viewCount: 560000,
    publishDate: '2026-05-10',
    featured: false,
  },
];

export const faqs: FAQ[] = [
  {
    question: '亚洲国产高清平台提供哪些类型的影视内容？',
    answer: '我们平台涵盖国产剧集、高清电影、热门综艺、动漫动画、纪录片、短剧微剧等六大类别的亚洲国产高清影视内容。无论是热播大剧、经典电影、还是小众佳作，您都能在这里找到高品质的观看推荐和深度内容解读。',
  },
  {
    question: '平台上的影视内容可以免费观看吗？',
    answer: '亚洲国产高清是一个影视内容精选推荐平台，我们提供专业的影视资讯、深度评测和观看指南。具体影片的观看链接会指向各正版视频平台，您可以通过我们在各平台观看正版高清内容。',
  },
  {
    question: '如何找到我感兴趣的影视内容？',
    answer: '您可以通过首页的分类导航（剧集、电影、综艺、动漫、纪录片、短剧）快速定位感兴趣的内容类型，也可以使用搜索功能（即将上线）精确查找。每篇文章都标注了详细的标签和分类，方便您发现更多相关内容。',
  },
  {
    question: '平台上的影视内容是否支持高清画质？',
    answer: '是的，我们平台聚焦于"亚洲国产高清"内容，所有推荐的影视作品均支持高清及以上画质（720P/1080P/4K），确保您获得最佳的视听体验。每篇文章中我们也会标注该内容的最高可用画质。',
  },
  {
    question: '平台多久更新一次内容？',
    answer: '我们保持每日更新的频率，及时为您带来最新的亚洲国产高清影视资讯。热播剧集和热门电影上线后，我们会在24小时内发布深度评测和观看指南。综艺节目和纪录片也会在播出后第一时间跟进。',
  },
  {
    question: '如何联系我们或提供反馈？',
    answer: '您可以通过"关于我们"页面的联系表单与我们取得联系。我们重视每一位用户的反馈和建议，通常会在1-2个工作日内回复。您也可以关注我们的社交媒体账号获取最新动态。',
  },
];

export const testimonials = [
  {
    name: '张先生',
    role: '影视爱好者',
    content: '亚洲国产高清是我每天必逛的影视平台，推荐的内容质量非常高，影评也写得很专业。通过这里发现了很多宝藏国产剧！',
    rating: 5,
  },
  {
    name: '李女士',
    role: '追剧达人',
    content: '分类做得特别清晰，找剧非常方便。高清画质的推荐标准让我省去了很多筛选的时间，每篇评测都很中肯。',
    rating: 5,
  },
  {
    name: '王同学',
    role: '电影专业学生',
    content: '作为电影专业的学生，我特别欣赏平台对国产影视内容的深度剖析。不只是推荐，还有文化背景和制作幕后，非常有启发性。',
    rating: 5,
  },
];